(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('statusLabel', statusLabel);

    /** @ngInject */
    function statusLabel() {
        return function(status) {
          if (!status) return '';
          return status.replace(/_/g, ' ');
        };
    }

})();
